import { DriveItemId } from '@/drive/entities/DriveItemId';
import { DriveItemRequest } from '@/drive/types/DriveItemRequest';
import { BaseProductType } from '@/product/constants/productTypes';
import { ProductId } from '@/product/entity/Product';

export enum PinnedItemType {
  CarbonProject = 'carbonProject',
  Product = 'product',
  Url = 'url',
}

// Serialized shape persisted in storage; the classes only keep data fields after JSON round trip.
export type PinnedItemModel =
  | { type: PinnedItemType.Product; productId: ProductId; productType: BaseProductType }
  | { type: PinnedItemType.CarbonProject; projectId: string }
  | { type: PinnedItemType.Url; driveItemId: DriveItemId; url: string };

export interface PinnedItem {
  // Id for any PinnedItem is stable (e.g. creating a PinnedItem from the same entity produces the same id).
  readonly id: string;
  readonly type: PinnedItemType;
  getUrl(): string;
  toDriveItemRequest(): DriveItemRequest;
  toModel(): PinnedItemModel;
}
